export default {
  // System Notifications
  notifGeoTitle: 'Geolocation',
  notifGeoSuccess: 'Geolocation signal active',
  notifGeoError: 'Geolocation signal lost',
  notifDataTitle: 'Data connexion',
  notifDataSuccess: 'Connected to data network',
  notifDataError: 'Internet connexion lost',
  // Map
  search: 'Search',
  settings: 'Settings',
  // Welcome
  skip: 'Skip',
  welcomeGeoTxt: 'Atlastories uses your geolocation to discover nearby places history',
  welcomeGeoBtn: 'Enable geolocation',
  welcomeUxTxt: 'Connect your headphones and prevent sleep mode for a better experience',
  welcomeUxBtn: 'Prevent sleep mode',
  welcomeGtuTxt: 'We use analytics and track errors to make this application better',
  welcomeGtuBtn: 'Read the terms of use',
  // Gtu
  agree: 'Agree',
  termsTitle: 'General terms of use',
  // Settings
  settingsTitle: 'Settings',
  settingsLang: 'Language',
  settingsMap: 'Map style',
  settingsGps: 'Satellite signal',
  settingsCache: 'Cache images',
  settingsNosleep: 'No sleep',
  settingsNosleepEnabled: 'The phone will never sleep',
  settingsNosleepDisabled: 'Inactivity turn of the screen',
  settingsKm: 'Metric system',
  settingsDark: 'Dark mode',
  settingsTerms: 'Terms of use',
  settingsCacheFooter: 'Cache images: XX day(s)',
  settingsGpsFooter: 'Precision: ',
  settingsKmFooter: 'Distance unit: ',
  settingsSubtitles: 'Subtitles',
  enabled: 'Enabled',
  disabled: 'Disabled',
  version: 'Version',
  // SettingsMap
  settingsMapTitle: 'Map styles',
  tilesbasic: 'Classic',
  tilesbright: 'Bright',
  tilesdarkmatter: 'Dark',
  tilespastel: 'Pastel',
  tilestopo: 'Topo',
  tilespositron: 'Grey',
  tileshybrid: 'Satellite',
  tilesstreets: 'Streets',
  tilesvoyager: 'Voyager',
  // SettingsLang
  settingsLangTitle: 'Langages',
  // Search
  searchPh: 'Search a place...',
  noResult: 'No result found',
  // footer
  footerDiscover: 'Discover history of nearby places',
  footerRead: 'Read article',
  // Route
  routeTitle: 'Itinerary',
  rmfoot: 'Walk',
  rmbike: 'Bike',
  rmcar: 'Car',
  routeLoading: 'Calculating route',
  // Geolocation
  geoErrDenied: 'Please check your device settings to allow access to your geolocation',
  geoErrGeneric: 'Your localisation is required to get the route information',
  geoLoading: 'Pending geolocation',
  geoButton: 'Activate geolocation',
  routeAway: 'You have left the road',
  routeStop: 'Stop following the track',
  routeBack: 'Get me back on track',
  // Article
  artPlay: 'Play',
  artPause: 'Pause',
  artStop: 'Stop',
  artRoute: 'Itinerary',
  artBookmark: 'Bookmark',
  // Generic
  close: 'Close', // article gallery

  // to remove?
  routeTo: 'Route to',
  swiperEmpty: 'No monument in the area, swipe the map!',
  playlistEmpty: 'Nothing to listen for now'
}
